<op-content-loader viewBox="0 0 200 140">
  <svg:rect x="10" width="90%" height="45" rx="1" />

  <svg:rect x="10" y="51" width="90%" height="45" rx="1" />

  <svg:rect x="10" y="102" width="90%" height="30" rx="1" />

</op-content-loader>
